<div class="footer">
  <div *ngIf="showInformationFooter" class="footer--informations">
    <fq-information-footer
      [isBigInformationFooter]="isBigInformationFooter"
    ></fq-information-footer>
  </div>
  <nx-footer>
    <div class="container-boxed">
      <nx-footer-copyright class="custom-footer-copyright">
        &copy; Allianz {{ currentYear }} - {{ 'footer.title' | translate }}
      </nx-footer-copyright>

      <nx-footer-navigation class="custom-footer-navigation">
        <nx-footer-link>
          <a rel="noopener" href="{{ 'footer.links.privacy.link' | translate }}" target="_blank">{{
            'footer.links.privacy.label' | translate | capitalize
          }}</a>
        </nx-footer-link>
        <nx-footer-link>
          <a rel="noopener" href="{{ 'footer.links.cookie.link' | translate }}" target="_blank">{{
            'footer.links.cookie.label' | translate | capitalize
          }}</a>
        </nx-footer-link>
        <nx-footer-link>
          <a
            rel="noopener"
            href="{{ 'footer.links.accessibility.link' | translate }}"
            target="_blank"
            >{{ 'footer.links.accessibility.label' | translate | capitalize }}</a
          >
        </nx-footer-link>
      </nx-footer-navigation>
    </div>
    <div [style.height.px]="height" class="spaceStickyMobile"></div>
  </nx-footer>
</div>
